import React, { useState, useEffect } from 'react';
import { useFirebase } from '../FirebaseContext';
import '../style/account.css';
import { signInWithRedirect, GoogleAuthProvider, getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { doc, deleteDoc, getFirestore } from 'firebase/firestore';
import { ref, deleteObject, getStorage } from 'firebase/storage';

const Account = () => {
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(null); // Initialize to null
  const app = useFirebase();
  const auth = getAuth(app);
  const firestore = getFirestore(app);
  const storage = getStorage(app);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setIsLoggedIn(!!user); // Update isLoggedIn when authentication state changes
    });
    return () => unsubscribe();
  }, [auth]);

  const signInWithGoogle = async () => {
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      await signInWithRedirect(auth, provider);
      await setPersistence(auth, browserLocalPersistence);
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await auth.signOut();
    } catch (error) {
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    setLoading(true);
    try {
      const reference = ref(storage, `users/${auth.currentUser.uid}`);
      await deleteObject(reference);
      const document = doc(firestore, `users/${auth.currentUser.uid}`);
      await deleteDoc(document);
      await auth.currentUser.delete();
    } catch (error) {
      console.error('Error deleting account:', error);
      alert(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || isLoggedIn === null) {
    return <p className='account-container'>Loading...</p>;
  }

  return (
    <div className='account-container'>
      <h2>Account Settings</h2>
      {isLoggedIn ? (
        <>
          <button className='logout-button' onClick={handleSignOut}>
            Logout
          </button>
          <button className='delete-account-button' onClick={handleDeleteAccount}>
            Delete Account
          </button>
        </>
      ) : (
        <button className='google-signin-button' onClick={signInWithGoogle}>
          {loading ? 'Signing In...' : 'Sign In with Google'}
        </button>
      )}
    </div>
  );
};

export default Account;
